<template>
  <div id="page-editor" class="editor">
    <nav class="sub-page-nav has-text-centered">
      <back-arrow></back-arrow>
      <h1 class="is-cs-3">ショップ編集</h1>
    </nav>
    <div class="page-status" v-if="$store.getters.isMember" :class="{publish: originalPage.publish}">
      <p>{{ $store.getters.pageStatus }}</p>
    </div>
    <div class="wrapper">
      <header>
        <div>
          <figure class="image" v-for="(image, index) in page.images"
            :id="pageImages[index].id" :key="index">
            <cachalog-img :type="'background'" :class="pageImages[index].class[1]" :caption="image.caption"
              :full-path="image.full_path" :source="image.source" :edit="true"></cachalog-img>
            <div class="camera-icon" @click="takePicture(pageImages[index].id)">
              <i class="c-icon cachalog-camera">
                <span class="path1"></span><span class="path2"></span>
              </i>
            </div>
          </figure>
        </div>
      </header>
      <div class="properties">
        <div>
          <label>URL</label>
          <span>{{ cachalogUrl + page.id }}</span>
        </div>
        <div class="name">
          <label for="form-title">名前</label>
          <input type="text" name="title" id="form-title" placeholder="ショップ名を追加" v-model="page.title" />
          <p class="notice is-c-alert-text has-text-centered" v-if="!validTitle && page.title">30文字以内で入力してください。</p>
        </div>
        <div class="link">
          <label for="form-link">サイト</label>
          <div>
            <input type="url" name="link" id="form-link" placeholder="Webサイトを追加" v-model="page.links[0].url" />
            <p class="notice is-c-alert-text" v-if="!validSiteUrl">URLを正しく入力してください。</p>
          </div>
        </div>
        <div class="description">
          <label for="form-description">ショップの情報</label>
          <textarea name="description" id="form-description" rows="10" placeholder="ショップの自己紹介を追加" v-model="page.description">
          </textarea>
        </div>
        <!--
        <div class="period">
          <label for="form-period">公開期間</label>
          <div class="column">
            <div>
              <input type="radio" id="unsetPeriod" name="period" value="unset" v-model="setPeriod">
              <label for="unsetPeriod" class="has-text-weight-normal">設定しない</label>
            </div>
            <div>
              <input type="radio" id="setPeriod" name="period" value="set" v-model="setPeriod">
              <label for="setPeriod" class="has-text-weight-normal">設定する</label>
            </div>
            <div>
              <span>開始</span><input type="date" id="form-period" :disabled="setPeriod === 'unset'" :value="dates[0].date ? datestr(dates[0].date, 'Y-m-d') : '00-00-00'" @change="updateDate($event, 0)" />
              <button @click="clearDate(0)">クリア</button>
            </div>
            <div>
              <span>終了</span><input type="date" id="form-period" :disabled="setPeriod === 'unset'" :value="dates[1].date ? datestr(dates[1].date, 'Y-m-d') : '00-00-00'" @change="updateDate($event, 1)" />
              <button @click="clearDate(1)">クリア</button>
            </div>
          </div>
        </div>
        -->
        <div class="publish switch">
          <label for="form-publish">公開</label>
          <input name="publish" id="form-publish" type="checkbox" :checked="page.publish" @change="updatePublish($event)">
          <label for="form-publish">
            <span class="is-cs-5">{{ page.publish ? '公開' : '非公開' }}</span>
          </label>
        </div>
      </div>
      <div class="has-text-centered">
        <button class="button is-rounded is-c-primary is-large" :disabled="!validTitle || !validSiteUrl" @click="savePage">保存</button>
      </div>
      <div class="has-text-centered">
        <button class="button is-rounded is-c-alert is-large" @click="deletePage">ショップの削除</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import { db, mixin, indexOf, datestr, incrementCounter } from './common.js'
import backArrow from './design/back-arrow.vue'
export default {
  components: {
    'back-arrow': backArrow
  },
  mixins: [mixin],
  props: ['pageId'],
  data: () => ({
    status: null,
    setPeriod_: null,
    imagePosition: null
  }),
  computed: {
    ...Vuex.mapState({
      cachalogUrl: 'cachalogUrl',
      user: 'user',
      originalPage: 'page',
      page: 'tempPage',
      pageImages: 'pageImages',
      imageSourceQueue: 'imageSourceQueue'
    }),
    setPeriod: {
      get () {
        if (this.setPeriod_) {
          return this.setPeriod_
        } else {
          return this.dates.some(date => {
            return date.date
          }) ? 'set' : 'unset'
        }
      },
      set (value) {
        this.setPeriod_ = value
      }
    },
    validTitle () {
      return this.page.title && this.page.title.length <= 30
    },
    validSiteUrl () {
      return !this.page.links[0].url || this.page.links[0].url.match(/^(http|https):\/\/\w+\.\w+/)
    },
    _dates () {
      return this.dates.map(date => {
        if (this.setPeriod === 'unset') {
          return null
        } else {
          return date && date.date ? date : null
        }
      })
    },
    dates () {
      const dates = []
      for (let i = 0; i < 2; i++) {
        let date = this.page.dates[i]
        let d = {date: null}
        if (date && date.date.seconds) {
          d = {date: date.date.toDate()}
        } else if (date && date.date) {
          d = {date: date.date}
        }
        dates[i] = d
      }
      return dates
    }
  },
  watch: {
    imageSourceQueue (value) {
      for (let i = 0; i < this.pageImages.length; i++) {
        const index = indexOf(value, 'position', this.pageImages[i].id)
        if (index !== false) {
          this.page.images.splice(i, 1, value[index])
          this.$store.commit('dequeueImageSource')
          if (!this.page.images[i].id) {
            incrementCounter(db.doc('pages/' + this.page.id), 'images_counter')
              .then(n => (this.page.images[i].id = n))
              .catch(error => console.error(error))
          }
        }
      }
    }
  },
  methods: {
    datestr (date, format) {
      return datestr(date, format)
    },
    clearDate (i) {
      Vue.set(this.page.dates, i, null)
    },
    updateDate (e, index) {
      Vue.set(this.page.dates, index, {date: new Date(e.target.value)})
    },
    updatePublish (e) {
      Vue.set(this.page, 'publish', e.target.checked)
    },
    takePicture (position) {
      this.$store.commit('storeImagePosition', position)
      document.querySelector('#image-capture input').click()
    },
    savePage () {
      const page = {
        id: this.page.id,
        title: this.page.title || '',
        links: this.page.links,
        description: this.page.description || '',
        images: this.page.images,
        dates: this._dates,
        publish: this.page.publish || false,
        created: this.page.created
      }
      this.$store.dispatch('updatePage', page)
      const usersPage = this.user.pages[indexOf(this.user.pages, 'id', this.page.id)]
      this.$store.dispatch('addPageToUser', Object.assign(usersPage, page))
      if (this.status === 'new') {
        this.$router.push({name: 'page'})
      } else {
        this.$router.go(-1)
      }
    },
    deletePage () {
      const pageId = prompt('削除するショップのIDを入力してください。\nショップID: ' + this.pageId)
      if (pageId === this.pageId) {
        if (confirm(this.cachalogUrl + pageId + '\n' + this.page.title + 'を削除します。よろしいですか？')) {
          this.$store.dispatch('deletePage', this.page)
        }
      } else {
        if (pageId !== null) {
          alert('IDが違います。')
        }
      }
    }
  },
  created () {
    if (this.originalPage.id !== this.pageId) {
      this.$router.replace({name: 'page'})
      return false
    }
    this.status = this.originalPage.title ? '' : 'new'
    const temp = {...{}, ...this.originalPage}
    temp.images = [...this.originalPage.images]
    temp.dates = [...this.originalPage.dates]
    this.$store.commit('storeTempPage', temp)
  },
  mounted () {
    /**
     * pageが遅れて読み込まれるためtransitionの実行に間に合わないのでcreatedじゃなくてmounted
     * そして.noneを追加
     */
    document.querySelector('.main-page').classList.add('none')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-editor.vue